import { useAuth } from '../../hooks/useAuth';
import AdminDashboard from './AdminDashboard';
import CustomerDashboard from './CustomerDashboard';
import TicketManagerDashboard from './TicketManagerDashboard';
import DepartmentManagerDashboard from './DepartmentManagerDashboard';

export default function DashboardApp() {
  const { role, permissions } = useAuth();
  const hasPerspective = (perm) => permissions.includes(perm);

  if (hasPerspective('DASHBOARD:ADMIN')) {
    return <AdminDashboard />;
  }

  if (hasPerspective('DASHBOARD:DEPT_MANAGER')) {
    return <DepartmentManagerDashboard />;
  }

  if (hasPerspective('DASHBOARD:OPERATOR')) {
    return <TicketManagerDashboard />;
  }

  if (hasPerspective('DASHBOARD:CUSTOMER')) {
    return <CustomerDashboard />;
  }

  return (
    <div style={{ padding: 20 }}>
      <h3>Loading dashboard for role: {role || 'Unknown'}...</h3>
      <p>If this screen stays, check if your user has a role assigned in the database.</p>
    </div>
  );
}
